import React from "react";

import { PetsReportController } from "../../../../services/controllers/reports";
import { usePetsReport } from "../../../../store/reports/usePetsReport";
import { formatMoney } from "../../../../services/functions";

import { AbsenceBadge } from "../../../../components/ui/AbsenceBadge";
import { Pagination } from "../../../../components/ui/Pagination";
import { Table } from "../../../../components/ui/Table";

const SORTABLE_COLUMN_KEYS = {
  Tutor: "customerName",
  Pet: "petName",
  CPF: "customerCpf",
  Telefone: "cellphone",
  Agendamentos: "totalAppointments",
  "Última visita": "lastAppointment",
  Ausência: "absenceDays",
  "Ticket médio": "averageTicket",
  "Receita total": "totalSales",
  "Tem pacote": "hasPackage",
  Assinante: "isSubscriber",
};

function YesNo({ value }) {
  if (!value) return <span className="text-gray-400">Não</span>;
  return <span className="font-semibold text-scale-600">Sim</span>;
}

export function PetsReportTable() {
  const CPetsReport = PetsReportController();

  const page = usePetsReport((st) => st.data.pagination.page);
  const paginationData = usePetsReport((st) => st.data.pagination);
  const pets = usePetsReport((st) => st.data.petsReport);
  const sort = usePetsReport((st) => st.data.sort);
  const isWaiting = usePetsReport((st) => st.data.isWaiting);

  return (
    <Table.Root name={CPetsReport.tableName} config>
      <Table.Header
        columns={[
          "Tutor:minmax(150px, 260px)",
          "Pet:minmax(105px, 200px)",
          "CPF:120px",
          "Telefone:115px",
          "Agendamentos:110px",
          "Última visita:105px",
          "Ausência:100px",
          "Ticket médio:105px",
          "Receita total:105px",
          "Tem pacote:95px",
          "Assinante:90px",
        ]}
        sortableConfig={{
          sortBy: sort.sortBy,
          sortOrder: sort.sortOrder,
          onSort: CPetsReport.handleSortColumn,
          columnKeys: SORTABLE_COLUMN_KEYS,
        }}
      />

      <Table.Content isLoading={isWaiting}>
        {!!pets[page] &&
          pets[page].map((pet) => (
            <Table.Line key={pet.id}>
              <Table.Item title={pet.customerName}>{pet.customerName}</Table.Item>
              <Table.Item title={pet.petName}>{pet.petName}</Table.Item>
              <Table.Item>{pet.cpfLabel}</Table.Item>
              <Table.Item>{pet.cellphone}</Table.Item>
              <Table.Item className="text-right">{pet.totalAppointments}</Table.Item>
              <Table.Item>{pet.lastAppointment || "-"}</Table.Item>
              <Table.Item>
                <AbsenceBadge days={pet.absenceDays} />
              </Table.Item>
              <Table.Item className="text-right">R$ {formatMoney(pet.averageTicket)}</Table.Item>
              <Table.Item className="text-right">R$ {formatMoney(pet.totalSales)}</Table.Item>
              <Table.Item>
                <YesNo value={pet.hasPackage} />
              </Table.Item>
              <Table.Item>
                <YesNo value={pet.isSubscriber} />
              </Table.Item>
            </Table.Line>
          ))}
      </Table.Content>

      <Pagination.Root
        name={CPetsReport.paginationName}
        totalPages={paginationData.totalPages}
        currentPage={paginationData.page}
        onChange={CPetsReport.setPage}
      >
        <Pagination.Back />
        <Pagination.Pages />
        <Pagination.Forward />
      </Pagination.Root>
    </Table.Root>
  );
}
